import { pushToDataLayer } from '@thg-commerce/enterprise-metrics/src/data_layer'

export const dataTracking = {
  sendCategoryTitleHandler: (trackedTopic?: string) => {
    return pushToDataLayer({
      type: 'elysiumEvent',
      eventData: {
        eventAction: 'Clicked',
        eventCategory: 'Help Centre',
        eventLabel: trackedTopic,
        eventLabelValue: undefined,
      },
    })
  },
  searchTermHandler: (term: string) => {
    return pushToDataLayer({
      type: 'elysiumEvent',
      eventData: {
        eventAction: 'Search terms',
        eventCategory: 'Help List Page',
        eventLabel: term,
        eventLabelValue: undefined,
      },
    })
  },
}
